export const cleanLink = (url: string) => {
    return url
        .toLowerCase()
        .replace(/ /g, `-`)
        .replace(/[^a-zA-Z0-9\-+]/g, ``);
};
